import { FormSection } from '@@/form-components/FormSection';

interface Props {
  title: string;
  message: string;
}

/**
 * Shows a consistent empty-state block for read-only policy sections.
 */
export function PolicyEmptyState({ title, message }: Props) {
  return (
    <FormSection title={title}>
      <div className="text-muted text-sm p-4 bg-gray-2 th-dark:bg-gray-iron-10 rounded-lg border border-gray-5 th-dark:border-gray-7">
        {message}
      </div>
    </FormSection>
  );
}
